window["dataset"] =  window['dataset']  ||  {}

export default {
    
    name:"DataSetAddUserStepper",
  
  data: () => ({
    language: ""
  }),
  components: {
    ...window["dataset"].default
},

  mounted() {
    this.language = localStorage.getItem("UserLang")
      ? localStorage.getItem("UserLang")
      : this.$i18n.locale;
  }
};
